export default __webpack_public_path__ + "static/media/myImage.d4a73816.jpg";